export default {
  all: {
    loading: false,
    items: [],
  },
};
